<template>
    <div>
        <add-item-button
            title="Add Item"
            @click="addItem"
            size="xs"
        />
    </div>
</template>

<script>
    import AddItemButton from '../../../common/reservation-add-item-button.vue';

    export default {
        components: {
            AddItemButton,
        },
        data() {
            return {
                busy: false,
            };
        },
        methods: {
            addItem() {
                this.params.addItem();
            },
        },
    };
</script>

<style lang="scss" scoped></style>
